export default __webpack_public_path__ + "static/key-logo-full-ed07b111d47df8332ecb28e8e5479dd7.png";